import { Component, OnDestroy, inject } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
    templateUrl: "./infoportal-contract-documents-page.component.html",
    styleUrls: ["./infoportal-contract-documents-page.component.scss"],
    standalone: false
})
export class InfoportalApiContractDocumentsPageComponent implements OnDestroy {
  private _subs = new Subscription();
  public contractNo = "";

  constructor() {
    const route = inject(ActivatedRoute);

    this._subs.add(
      route.queryParams
        .pipe(tap(this._handleQueryParamsChange.bind(this)))
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private _handleQueryParamsChange(params: Params) {
    if (!params.contractNo || this.contractNo === params.contractNo) {
      return;
    }
    this.contractNo = params.contractNo;
  }
}
